import React from "react";
import Slider from "react-slick";
import dipali from "../assets/img/Dipali.jpeg";
import prasad from "../assets/img/Prasad.jpeg";
import raghunath from "../assets/team/Raghu.png";
import onkar from "../assets/img/Onkar.jpeg";
import ashvini from "../assets/team/Hr.webp";
import bhushan from "../assets/team/Bhushan.jpeg";
import krutika from "../assets/team/Krutika2.jpeg";
import omkar from "../assets/team/Omkar2.jpeg";
import sanchit from "../assets/team/Sanchit.jpeg";
import shital from "../assets/team/Shital.jpeg";
import sonali from "../assets/team/Sonali.jpeg";
import shubhangi from "../assets/team/shubhangi.jpeg"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const teamMembers = [
  {
    name: "Raghunath Bade",
    position: "Founder , Managing Director",
    img: raghunath,
  },
  { name: "Ashwini Jagdale", position: "HR", img: ashvini },
  { name: "Dipali Wadekar", position: "Manager", img: dipali },
  { name: "Omkar Mhaske", position: "Technical Lead", img: omkar },
  { name: "Onkar Kulkarni", position: "Backend Lead", img: onkar },
  { name: "Krutika Chougule", position: "Frontend Lead", img: krutika },
  { name: "Sanchit Shitole", position: " Backend Developer", img: sanchit },
  { name: "Bhushan Titurkar", position: " Backend Developer", img: bhushan },
  { name: "Shital Gade", position: " Backend Developer", img: shital },
  {name:"Sonali Chadhari",position:"Backend Developer",img:sonali},
  { name: "Prasad Ghanekar", position: "Tester", img: prasad },
  {name:"Shubhangi Nikalje",position:"Digital Marketer",img:shubhangi}  
];

const OurTeam = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-gradient-to-b from-gray-800 to-black py-12">
      <h2 className="text-4xl font-bold text-center mb-12 text-white">
        The Brilliant Minds Behind the Project
      </h2>

      <div className="px-6">
        <Slider {...settings}>
          {teamMembers.map((member, index) => (
            <div key={index} className="px-3">
              <div className="bg-gray-900 text-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:scale-105 transform transition-transform duration-300">
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-40 h-40 rounded-full object-cover mb-4 border-4 border-gray-700"
                />
                <h3 className="text-2xl font-semibold text-gray-100">
                  {member.name}
                </h3>
                <p className="text-gray-400 mt-2 text-lg">{member.position}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default OurTeam;
